const FormAlreadySubmitted = () => (
  <div
    className="d-flex align-items-center justify-content-center"
    style={{ minHeight: "100vh" }}
  >
    <div className="text-center p-5" style={{ maxWidth: "500px" }}>
      <div className="card shadow-lg border-0" style={{ borderRadius: "20px" }}>
        <div className="card-body p-5">
          {/* Success Icon */}
          <div className="mb-4">
            <div
              className="mx-auto d-flex align-items-center justify-content-center"
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #28a745, #20c997)",
                boxShadow: "0 8px 25px rgba(40, 167, 69, 0.3)",
              }}
            >
              <i
                className="fas fa-check text-white"
                style={{ fontSize: "2rem" }}
              ></i>
            </div>
          </div>

          {/* Title */}
          <h2 className="mb-3 fw-bold" style={{ color: "#2c3e50" }}>
            Form Already Submitted
          </h2>

          {/* Message */}
          <p
            className="text-muted mb-4"
            style={{ fontSize: "1.1rem", lineHeight: "1.6" }}
          >
            Thank you! This form has already been submitted and cannot be
            edited.
          </p>

          {/* Decorative Line */}
          <div
            className="mx-auto mb-4"
            style={{
              width: "60px",
              height: "3px",
              background: "linear-gradient(90deg, #28a745, #20c997)",
              borderRadius: "2px",
            }}
          ></div>

          {/* Additional Info */}
          <div
            className="bg-light p-3 rounded"
            style={{ borderRadius: "12px" }}
          >
            <small className="text-muted">
              <i className="fas fa-info-circle me-2"></i>
              Your submission has been successfully recorded in our system.
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FormAlreadySubmitted;
